import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const Safety = () => {
    return (
        <div id="safety">
            <ContentBlock className="evFundamentalsSection">
                <ContentHeading title="Safety" />
                <ContentBody>
                    <div className="heading5">When it comes to safety, EVs are as safe as combustion engine vehicles. Like conventional vehicles, commercially available EVs must meet rigorous testing and safety standards set by government and industry organizations and their charging equipment must meet relevant electrical and safety requirements.</div>
                    <Row className="contentBlock tableBlock">
                        <Col>
                            <Table responsive className="table-striped-columns safetyRegulators">
                                <caption>Safety Regulators for EVs and EV Charging Equipment</caption>
                                <thead>
                                    <tr>
                                        <th className="text-left">Electric Vehicles</th>
                                        <th className="text-left">Electric Vehicle Charging Equipment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-left">Federal Motor Vehicle Safety Standards</td>
                                        <td className="text-left">Underwriters Laboratories</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Society of Automotive Engineers</td>
                                        <td className="text-left">CSA International</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">National Electric Vehicle Infrastructure Working Council</td>
                                        <td className="text-left">Edison Testing Laboratories</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Insurance Institute for Highway Safety</td>
                                        <td className="text-left">N/A</td>
                                    </tr>
                                </tbody>
                            </Table>

                            <div className="subContent">
                                <div className="body">
                                    <p>Collision, property damage, liability, and injury claims data analyzed by the Insurance Institute for Highway Safety for nine vehicle models from 2011 to 2019 showed that rates of injury claims related to the drivers and passengers of EVs were more than 40% lower than rates for similar conventional models.</p>
                                </div>
                                <h4 className="css_heading bold">Emergency response for EVs is no different from that of conventional vehicles.</h4>
                                <div className="body indent">
                                    <ul>
                                        <li>Built-in safety mechanisms protect drivers and first responders in case of accidents.</li>
                                        <li>Manufacturers publish emergency response guides for their vehicles and offer training for emergency responders.</li>
                                        <li>Battery packs are encased in sealed shells and designed for extreme temperatures, fire, collision, and water.</li>
                                        <li>All high-voltage power lines are clearly designated in orange.</li>
                                        <li>Cutoff switches isolate the battery and disable the electric system in the case of a collision or short circuit.</li>
                                    </ul>
                                </div>
                                <h4 className="css_heading bold">First responders are being trained to handle accidents involving EVs.</h4>
                                <div className="body indent">
                                    <ul>
                                        <li>National Fire Protection Association (NFPA) training is available at evsafetytraining.org.</li>
                                        <li>Read more about the NFPA Alternative Fuel Vehicle Safety Training project.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="referenceContent">
                                <p>Learn more at <a href="https://fueleconomy.gov" target="_blank" rel="noreferrer">FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/" target="_blank" rel="noreferrer">Alternative Fuels Data Center</a>.</p>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBlock>
        </div>
    );

};
